// extracted by mini-css-extract-plugin
export default {"grid":"order-form-questionnaire_grid__xAIEE"};